module.exports = __webpack_public_path__ + "img/ring_skip_skip_null_null@2x.55b6ce1b.png";